import styled from "styled-components";

import { clamp } from "@styles/utils/conversion.style";
import { colors } from "@styles/vars/colors.style";
import { mq } from "@styles/vars/media-queries.style";

export const TeamInfoMain = styled.section`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  width: 100%;
  overflow: hidden;
  background-color: ${colors.charcoal};
  color: ${colors.white};

  ${mq.tabletL} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const TeamInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  order: 2;
  min-width: 0;
  padding: 8rem 4rem;

  ${mq.tabletL} {
    order: 1;
    min-height: 100vh;
    padding: 8rem;
  }
`;

export const TeamInfoTitle = styled.h2`
  display: flex;
  align-items: baseline;
  gap: 0.8rem;
  margin: 0;
  color: ${colors.pastelGreen};
  font-family: Signifier;
  font-weight: 400;
  will-change: transform, opacity;

  ${clamp("font-size", 32, 48)};

  strong {
    font-family: National2;
    font-weight: 900;
  }
`;

export const TeamInfoText = styled.div`
  max-width: 58rem;
  margin-top: 6rem;
  color: ${colors.white};
  font-family: National2;
  font-weight: 400;
  will-change: transform, opacity;

  
  p {
    ${clamp("font-size", 24, 46)};
  }

  p + p {
    margin-top: 1em;
  }

  strong {
    color: ${colors.white};
    font-weight: 900;
  }

  em {
    font-style: italic;
  }

  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.15em;

    &:focus-visible {
      outline: 0.2rem solid ${colors.pastelGreen};
      outline-offset: 0.4rem;
    }
  }

  ${mq.tabletL} {
    margin-top: clamp(6rem, 7vw, 11rem);
  }
`;

export const TeamInfoImage = styled.div`
  position: relative;
  order: 1;
  width: 100%;
  min-height: 45rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    min-height: inherit;
    display: block;
    object-fit: cover;
    object-position: center;
  }

  ${mq.tabletL} {
    order: 2;
    min-height: 100vh;
  }
`;